export default __webpack_public_path__ + "static/media/clients-name.f626de18.svg";